import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import './Vetsmith.css';
import './VetsmithApt.scss';
import withVetsmithService from './Vetsmith.service';
import { ShowMCQList, ShowACCList, ShowMCQListV2 } from '../tests/shared';
import Instructions from './components/Instructions.modal';
import { Button, Tag, Tooltip, Popover, Upload } from 'antd';
import { CURRENT_YEAR_CONSTANT, PageConstant } from '../../../constants';
import { CheckMarkIcon, ClockIcon, CrossIcon,CalendarIcon, GradingSolutionIcon } from '../../components/common/CustomIcon';
import getEnv from '../../../../services/util/getEnv';
import APTWarning from '../../../components/Delights/APTWarning/APTWarning';
import moment from 'moment';
import 'moment-duration-format';
import { UserChallengeState } from '../CodingChallenge/CodingAndPracticalChallenges/constant';
import { redirectToVettingEngine } from '../../../../services/util/redirectToVettingEngine';
import FailedChallengePopoverContent from '../CodingChallenge/CodingAndPracticalChallenges/popover/FailedChallengePopoverContent';
import roundCheck from '../../../assets/img/round-check_circle-24px.svg';
import roundUncheck from '../../../assets/img/round-uncheck_circle-24px.svg';
import cloudUploadIcon from '../../../assets/img/devportal-cloud-upload.svg';
import cloudUploadIconDisabled from '../../../assets/img/devportal-cloud-upload-disabled.svg';
import queryString from 'query-string';
import { openNotification } from '../profile/Profile.actions';
import { isNil } from 'lodash';
import { useSaveDwellTime } from '../../../../dv2_temporary_solution/services/dwellTime';
import { pushLog2DV2LogServer } from '../../../services/logging';
import { getUserObject } from '../../util/getUserFullName';

export const getUncompletedStep = (steps = {}) => {
  const uncompleted = Object.keys(steps).filter((item) => (!['instructions', 'customer_status_update'].includes(item.toLowerCase()) && !['completed', 'passed'].includes((steps[item].status || '').toLowerCase()) && !['completed', 'passed'].includes((steps[item]._status || '').toLowerCase()) && (steps[item].step_status || '').toLowerCase() === 'required'));
  return uncompleted.length;
};

export const isJobVetsmith = () => {
  if (typeof document === "undefined") return false;
  try {
    const url = new URL(document.URL);
    const pattern = /^\/dashboard\/jobs\/\d+\/specialized-vetting$/;
    return pattern.test(url.pathname);
  } catch (error) {
    console.error("Error parsing URL:", error);
    return false;
  }
};

function Vetsmith ({ infos, service, ldFlags, history }) {
  const { steps, isFileUploadAllowed } = infos;
  const message_completion = infos.flow.message_completion;
  const message_completion_title = infos.flow.message_completion_title || 'The flow has been completed successfully';
  const uncompleted_step_count = getUncompletedStep(steps);

  useEffect(() => {
    const params = queryString.parse(history.location.search);
    if (params.token) {
      delete params.token;
      history.push({
        search: queryString.stringify(params)
      });
    }
  }, [history]);

  const vetsmithFlowLog = {
    name: infos.flow.name,
    id: infos.flow.flow_id,
    is_completed: (!uncompleted_step_count || !isNil(infos.completed_date))
  };
  useSaveDwellTime('v1/vetsmith/dwell-time', infos.sessionId, vetsmithFlowLog, infos.source, infos.templateId);
  const vetsmithCompleted = (!uncompleted_step_count || !isNil(infos.completed_date));
  return (
    <div className="Vetsmith-bg">
      <div className="Vetsmith">
        <VetsmithWelcomeBanner infos={infos} service={service} vetsmithCompleted={vetsmithCompleted} />
        <div className="Vetsmith-content Vetsmith-boxes">
          {infos.steps.instructions ? <Instructions item={infos.steps.instructions} /> : null}
          {
            vetsmithCompleted ?
            <VetsmithCompleteCard infos={infos} service={service} title={message_completion_title} description={message_completion} />
            : infos.orderSteps.map(stepName => <VetsmithItem key={stepName} item={infos.steps[stepName]} service={service} ldFlags={ldFlags} isFileUploadAllowed={isFileUploadAllowed} subscribeCode={infos && infos.code ? infos.code : ''} />)
          }
          <p className="Vetsmith-txt">{infos.flow.bottom_line_message || ''}</p>
          
          {!isJobVetsmith() && <>
            <hr />
            <VetsmithOptOut goto={service.goto} optOut={service.optOut} />
          </>}
        </div>
        <div style={{ flex: 1 }} />
      </div>
    </div>
  );
}

Vetsmith.propTypes = {
  service: PropTypes.any,
  infos: PropTypes.any
};

function VetsmithOptOut ({ optOut }) {
  return (
    <>
      <p className="Vetsmith-txt">You can temporarily switch to your main dashboard with the "Go to Talent Portal" button at the top, and resume this job application when convenient. Alternatively, if you're seeking a different job, you may permanently exit this selection process using the opt-out button below.</p>
      <div className="Vetsmith-opt-out">
        <Button type="link" onClick={optOut}><span className="material-icons">cancel</span> <span>Opt out of this job opportunity</span></Button>
      </div>
    </>
  );
}

VetsmithOptOut.propTypes = {
  goto: PropTypes.func,
  optOut: PropTypes.func
};

function rep (text) {
  const Rexp = /(https?:\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
  return `${text || ''}`.replace(Rexp, "<a href='$1' target='_blank'>$1</a>");
}
function VetsmithWelcomeBanner ({ infos, service, vetsmithCompleted = false }) {
  return (
    <div className="Vetsmith-welcome-banner">
      <div className={`Vetsmith-content welcome-banner-content ${vetsmithCompleted ? 'completion-banner' : ''}`}>
        {!service.props.showNavBar && <Button className="Vetsmith-btn-back" type="link" onClick={() => {
          localStorage.removeItem('redirect_url');
          localStorage.removeItem('jobCode');
          localStorage.removeItem('directJobApplicationReferrer');
          service.createPassword(PageConstant.DASHBOARD_DEV);
        }}><span className="material-icons">arrow_back</span> <span>Go to Talent Portal</span></Button>}
        <span className="Vetsmith-t1">Welcome</span>
        <span className="Vetsmith-t2">{infos.full_name}</span>
        <span className="Vetsmith-t3">{infos.flow.header_title}</span>
        <span className="Vetsmith-t4" dangerouslySetInnerHTML={{ __html: rep(infos.flow.header_description) }} />
      </div>
    </div>
  );
}

VetsmithWelcomeBanner.propTypes = {
  infos: PropTypes.any,
  service: PropTypes.any
};

function VetsmithFooter () {
  return (
    <div className="Vetsmith-footer">
      <div className="Vetsmith-content">
        <span>© {(new Date()).getFullYear()} Turing Enterprises, Inc.</span>
      </div>
    </div>
  );
}

export function VetsmithCompleteCard ({ title, description, infos, service }) {
  let icon = <span className="material-icons">list</span>;
  const flowId = infos && infos.flow && infos.flow.flow_id;
  const redirectToChallenge = flowId && +flowId === +getEnv("REACT_APP_VETSMITH_OPENAI_PYTHON_FLOW_ID")
  const redirectLink = redirectToChallenge ? PageConstant.CODING_CHALLENGE : PageConstant.DASHBOARD_DEV;
  switch (service.getJobStatus(infos.job_match_status)) {
    case 'In Review':
      icon = <span className="material-icons-round">person_search</span>;
      break;
    case 'Interviewing':
      icon = <span className="material-icons-round">support_agent</span>;
      break;
    case 'Hired':
      icon = <span className="material-icons-round">how_to_reg</span>;
      break;
    case 'Not selected':
      icon = <span className="material-icons-round">highlight_off</span>;
      break;
  }
  return (
    <div className='Vetsmith-item completed-section'>
      <div className='completed-section-content'>
        <div className='completed-title'>{title}</div>
        <div className='completed-description'>{description}</div>
        <Button type="primary" onClick={() => {
          localStorage.removeItem('redirect_url');
          service.createPassword(redirectLink)
        }}>{!redirectToChallenge ? <span className="material-icons">person_pin</span> : null} Go to the Talent Portal</Button>
      </div>
    </div>
  );
}

const calculateChallengeRetakeTime = (item) => {
  const ninetyDays = moment(item.submitTime).add(90, 'days');
  const daysDiff = moment(ninetyDays).diff(moment(), 'days');
  const hoursDiff = moment(ninetyDays).diff(moment(), 'hours');
  let retakeTime = '';
  let timeTip = '';

  if (item.passed === false) {
    if (daysDiff < 1 && daysDiff > -1 && hoursDiff > 0) {
      retakeTime = `${hoursDiff} hr`;
      timeTip = `You will be able to take this test again in ${hoursDiff}${
        hoursDiff > 1 ? ' hrs' : ' hr'
      }.`;
    } else if (daysDiff > -1 && daysDiff < 1 && hoursDiff < 1) {
      retakeTime = '< 1 hr';
      timeTip = 'You will be able to retake this test again soon.';
    } else if (daysDiff >= 1) {
      retakeTime = `${daysDiff} d`;
      timeTip = `You will be able to take this test again in ${daysDiff}${
        daysDiff > 1 ? ' days' : ' day'
      }.`;
    }
  }

  return { retakeTime, timeTip };
};

const PassStatusButton = (item) => {
  const { failedAPTModalShow } = item;
  const { retakeTime } = calculateChallengeRetakeTime(item);
  return (
    <React.Fragment>
      {item.passed ? (
        <Button
          disabled={true}
          type="link"
          className="turing-ui-v2-completed-apt"
        >
          <span>Completed</span>
        </Button>
      ) : (
        <Popover
          content={
            <FailedChallengePopoverContent
              retakeTime={retakeTime.replace('d', 'days')}
            />
          }
          trigger="click"
          open={failedAPTModalShow[item.challengeId]}
          overlayClassName="failed-apt-popup"
          placement="rightBottom"
          onOpenChange={() =>
            setFailedAPTModalShow({ [item.challengeId]: true })
          }
        >
          <Button
            className="turing-ui-v2-reattempt apt"
            disabled={false}
            type="link"
          >
            <span>What can I do now?</span>
          </Button>
        </Popover>
      )}
    </React.Fragment>
  );
};

const PassStatusToolTip = (item) => {
  const { retakeTime, timeTip } = calculateChallengeRetakeTime(item);
  return (
    <React.Fragment>
      {item.passed === true && (
        <Tag className="passed">
          <CheckMarkIcon />
          <span>Passed</span>
        </Tag>
      )}
      {item.passed === false && (
        <span className="didntpass-wrap">
          <Tooltip
            placement="top"
            title={
              <span className="tooltip-message">
                {moment(item.submitTime).format('MMM D YYYY, hh:mmA')}
              </span>
            }
          >
            <Tag className="didntpass">
              <CrossIcon className="didntpass-icon" />
              <span>Didn't Pass</span>
            </Tag>
          </Tooltip>
          <Tooltip
            placement="top"
            title={<span className="tooltip-message">{timeTip}</span>}
          >
            <span className="retake">
              <CalendarIcon /> <span>{retakeTime}</span>
            </span>
          </Tooltip>
        </span>
      )}
    </React.Fragment>
  );
};

const PracticalChallengesSectionContent = (item, ldFlags, service) => {
  const [warningAPTModalShow, setWarningAPTModalShow] = useState({});
  const [failedAPTModalShow, setFailedAPTModalShow] = useState({});

  const setAPTWarningModalVisiblity = (aptChallengeId, show) => {
    const user = getUserObject();
    const aptChallenge = item.apt_challenges.find((challenge) => challenge.id === aptChallengeId);

    const logBody = {
      sessionId: service.state.sessionId,
      user,
      step: 'APT',
      action: show ? 'VETSMITH_OPEN_APT_MODAL' : 'VETSMITH_CLOSE_APT_MODAL',
      challenge: aptChallenge,
      flow_id: service.state.flow.flow_id
    };
    pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_APT_CTA`, {}, logBody);
  
    setWarningAPTModalShow({
      [aptChallengeId]: show,
    });
  }

  const startAPT = (aptChallengeId, maintenance_mcq_acc_apt = false) => {
    const cookieParams = { aptChallengeId };
    const link = PageConstant.VETTING_ENGINE_APT;
    if (maintenance_mcq_acc_apt) {
      openNotification(
        'info', 
        'Maintenance', 
        'We apologize for the inconvenience. This feature is currently undergoing maintenance to provide you with an even better experience. Please check back soon.', 
        20
      );
      return;
    }

    const user = getUserObject();
    const aptChallenge = item.apt_challenges.find((challenge) => challenge.id === aptChallengeId);
    const logBody = {
      sessionId: service.state.sessionId,
      user,
      step: 'APT',
      action: 'VETSMITH_START_APT',
      challenge: aptChallenge,
      flow_id: service.state.flow.flow_id
    };
    pushLog2DV2LogServer.info('VETSMITH_TRAIL', `VETSMITH_APT_CTA`, {}, logBody);
  
    let redirectUrl = service.getVetsmithFlowRedirectUrl();
    redirectUrl = window.location.origin + redirectUrl;
    redirectToVettingEngine(link, cookieParams, redirectUrl);
  };

  const { apt_challenges = [] } = item;
  const { gb_apt_instructions_config, show_apt_plagiarism_warning, show_apt_requirements_warning, maintenance_mcq_acc_apt = false } = ldFlags;

  return  <div className="challengesWrapper">
    <div className="challengeCards hasApt">
      {apt_challenges.length &&
        apt_challenges.map((test) => {
          const { currentState } = test;
          const { 
            submitted = '', 
            passed = false, 
            submitTime = '', 
            durationInSec = { total: 0, passed: 0 }, 
          } = currentState;

          const challengeDurationInMin =
            (durationInSec.total ? durationInSec.total : 0 ) / 60;
            const timeLeft = moment.duration(durationInSec.total - durationInSec.passed,'seconds').format('h [hr] m [m]');
          const aptChallengeId = test.id;

          return (
            <div className="turing-ui-v2-apt-tests-item" key={aptChallengeId}>
              <div className="turing-ui-v2-apt-tests-item-icon">
                <img
                  className="apt"
                  src={test.icon}
                  alt={test.name}
                />
              </div>
              <div className="turing-ui-v2-apt-tests-item-content">
                <span className="turing-ui-v2-apt-tests-item-title">
                  {test.name}
                </span>
                <span
                  className={`turing-ui-v2-apt-tests-item-time${
                    submitted === UserChallengeState.TODO
                      ? ' todo'
                      : ''
                  }`}
                >
                  {submitted === UserChallengeState.GRADING_SOLUTION && (
                    <Tooltip
                      placement="top"
                      title='Please check back in 5-10 minutes for final results'
                    >
                      <Tag className="grading-solution">
                        <GradingSolutionIcon className="grading-solution-icon" />
                        <span>Grading Challenge</span>
                      </Tag>
                    </Tooltip>
                  )}
                  {submitted === UserChallengeState.COMPLETED &&
                    PassStatusToolTip({
                      passed: passed,
                      submitTime: submitTime,
                    })}
                  {submitted ===
                    UserChallengeState.IN_PROGRESS && (
                    <div className="turing-ui-v2-apt-tests-item-time-left-wrap">
                      <span className="turing-ui-v2-apt-tests-item-time-left">
                        <ClockIcon />
                        <span>
                          {`${timeLeft} left`}
                        </span>
                      </span>

                      <span className="turing-ui-v2-apt-tests-item-time-paused">
                        Paused
                      </span>
                    </div>
                  )}
                  {submitted === UserChallengeState.TODO && (
                    <span className="turing-ui-v2-mcq-tests-item-time-estimate">
                      <ClockIcon
                        style={{ marginRight: 2, marginBottom: 2 }}
                      />
                      <span>Max. Time {challengeDurationInMin} m</span>
                    </span>
                  )}
                </span>
              </div>
              {submitted === UserChallengeState.GRADING_SOLUTION ?
                  null : submitted !== UserChallengeState.COMPLETED ? (
                <Button
                  className="actionItem turing-ui-v2-apt-tests-item-button"
                  onClick={() => {
                    setAPTWarningModalVisiblity(aptChallengeId, true)
                  }}
                >
                  <span>Start Challenge</span>
                </Button>
              ) : (
                <React.Fragment>
                  {PassStatusButton({
                    passed: passed,
                    submitTime: submitTime,
                    challengeId: test.id,
                    failedAPTModalShow: failedAPTModalShow
                  })}
                </React.Fragment>
              )}
              {warningAPTModalShow[aptChallengeId] && (
                <APTWarning
                  challengeDuration={challengeDurationInMin}
                  inProgress={
                    submitted === UserChallengeState.IN_PROGRESS
                  }
                  timeLeft={timeLeft}
                  isVisible={warningAPTModalShow[aptChallengeId]}
                  key={aptChallengeId}
                  challengeId={aptChallengeId}
                  show_apt_plagiarism_warning={show_apt_plagiarism_warning}
                  gb_apt_instructions_config={gb_apt_instructions_config}
                  show_apt_requirements_warning={show_apt_requirements_warning}
                  onStart={() => {
                    startAPT(
                      aptChallengeId,
                      maintenance_mcq_acc_apt
                    )
                  }}
                  onCancel={() => {
                    setAPTWarningModalVisiblity(aptChallengeId, false)
                  }}
                />
              )}
            </div>
          );
        })}
    </div>
  </div>
}

VetsmithCompleteCard.propTypes = {
  title: PropTypes.any,
  description: PropTypes.any,
  infos: PropTypes.any,
  service: PropTypes.any
};

function getAptStatus(item) {
  const Completed = (txt) => (
    <span className="Vetsmith-Completed">
      <img
        src={roundCheck}
        style={{
          width: 18,
          height: 18,
          background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
          opacity: 1
        }}
        alt="check"
      />
      <span>{txt}</span>
    </span>
  );
  const DidntPass = (
    <span className="Vetsmith-DidDidntPass">
      <img
        src={roundUncheck}
        style={{
          width: 18,
          height: 18,
          background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
          opacity: 1
        }}
        alt="check"
      />
      <span>Didn&apos;t pass</span>
    </span>
  );

  if (item.status === 'Passed') {
    return (
      <span className="Vetsmith-status">{Completed('Completed')}</span>
    );
  } 
  if (item.status === 'Failed') {
    return (
      <span className="Vetsmith-status">{DidntPass}</span>
    );
  }
  return null;
}

const TruncatedFileName = ({ fileName = " ", mainClass = "file-upload-status"}) => {
  const fileNameClasses = useMemo(() => {
    let fileClasses = "";
    if (fileName && fileName.length > 20) {
      fileClasses = `${mainClass} ${mainClass}--truncate`;
    } else {
      fileClasses = mainClass;
    }
    return fileClasses;
  }, [fileName]);

  return (
    <div className={fileNameClasses}>{fileName}</div>
  )
}


const FileUploadItem = ({ stepConfig, index, isLast }) => {
  return (
    <div className={`file-upload-item ${isLast ? '' : 'file-upload-underline'}`}>
      <div className="file-upload-number">{index + 1}.</div>
      <div className="file-upload-title">{stepConfig.title}</div>
      <div className="file-upload-button">
        <Upload {...stepConfig.uploadFileProps} multiple={false}>
          <Button type='link' className="file-upload-button-inner" title={`Allowed extensions: ${stepConfig.fileExtensions.join(',  ')} \n Maximum size: ${stepConfig.fileLimit/1024/1024}MB`}>
            <span className="material-icons">attachment</span> 
            <span className="file-upload-select-button">Select file</span>
          </Button>
          <input id="fakeElementToFocus" type="text" style={{ opacity: 0, position: 'absolute', pointerEvents: 'none' }} />
        </Upload>
      </div>
      <TruncatedFileName fileName={stepConfig.fileName} />
      {stepConfig.fileName ? (
          <div className="file-upload-delete-btn">
            <button type="button" className="ant-btn ant-btn-link" onClick={()=>stepConfig.onFileRemove(stepConfig.fileuid)}>
              <span className="material-icons file-upload-delete-file">close</span>
            </button>
          </div>)
        : null}
    </div>
  )
}

const RequiredPassCount = ({step_config, numberOfChallenges, challengeTypeName = 'challenges'}) => {

  if(!step_config || !step_config.required_pass_count) return null;

  let statement = '';

  if(numberOfChallenges === step_config.required_pass_count) {
    statement = `You are required to pass all of the following ${challengeTypeName} to complete this step.`
  } else if (step_config.required_pass_count === 1) {
    statement = `You are required to pass any one of the following ${challengeTypeName} to complete this step.`
  } else if (step_config.required_pass_count > 1){
    statement = `You are required to pass ${step_config.required_pass_count} ${challengeTypeName} from the following to complete this step.`
  }

  return (
     statement !== '' ? (
      <div className="Vetsmith-ws">
          <br/>
          {statement}
      </div>
    ) : null 
  );
};


export function VetsmithItem ({ item, ldFlags, subscribeCode, ribbon = true, hideStepCount = false, badge = null, showEstTime = true, isFileUploadAllowed = false, service }) {
  const Status = ['apt'].includes(item.step) ? getAptStatus(item) : item.Status;
  const ribbonClass = ribbon ? 'Vetsmith-item--ribbon': '';
  const showNumber = Boolean(item.num) && !hideStepCount;
  const { 
    use_vetsmith_challenge_versioning = false,
    use_vetsmith_mcq_challenge_versioning = false 
  } = ldFlags;
  return (
    <div className={`Vetsmith-item ${ribbonClass} ${['mcq_required', 'mcq_recommended', 'hyperlink', 'apt', 'multiple_lang_coding_challenge','file_upload','multiple_coding_challenge', 'technical_writing_assessment', 'rlhf_challenge', 'ai_challenge', 'nte_challenge'].includes(item.step) ? 'Vetsmith-item-wrap' : ''} ${item.disabled ? 'disabled' : ''} ${item.active ? 'active' : ''}`}>
      {showNumber? (
        <div className="Vetsmith-item-num">
          {item.num}
        </div>
      ) : null}
      <div className="Vetsmith-item-content">
        <span className="Vetsmith-item-title">{item.step_title} <span> {badge}</span> <span>{item.step_label}</span></span>
        <div className="Vetsmith-ws" dangerouslySetInnerHTML={{ __html: rep(item.step_description) }}/>
        {
          item.step === "mcq_required" ?
          <RequiredPassCount step_config={item.step_config ? item.step_config : {}} challengeTypeName='MCQs' numberOfChallenges={item.mcq ? item.mcq.length : 0}/>
          : <RequiredPassCount step_config={item.step_config ? item.step_config : {}} numberOfChallenges={item.acc ? item.acc.length : 0}/>
        }

      </div>
      {showEstTime && item.step_est_time ? (
        <span className="Vetsmith-esttime">
          <span className="Vetsmith-esttime-info">Est. time</span>
          <span className="Vetsmith-esttime-value">{item.step_est_time} min</span>
        </span>
      ) : showEstTime ? <span className="Vetsmith-esttime" /> : null}
      <div className={`Vetsmith-start-btn-container ${item.disabled ? 'disable-start-btn' : ''}`}>
        {['apt'].includes(item.step) ? Status : <Status />}
      </div>
      {['apt'].includes(item.step) ? 
        <div className={item.disabled ? 'apt-wrapper Vetsmith-item-content1 disable-mcq-btn' : 'apt-wrapper Vetsmith-item-content1'}>
          { PracticalChallengesSectionContent(item, ldFlags, service) }
        </div> : null
      }
      {['mcq_required', 'mcq_recommended'].includes(item.step) ? 
      <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}>
        {
          use_vetsmith_mcq_challenge_versioning ? 
            <ShowMCQListV2 dataSource={item.mcq} />
            :
            <ShowMCQList dataSource={item.mcq} />
        }
      </div> 
      : 
      null}
      {['multiple_lang_coding_challenge'].includes(item.step) ? 
            <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}>
              { use_vetsmith_challenge_versioning ?
                <ShowMCQListV2 dataSource={item.acc} />
                :
                <ShowMCQList dataSource={item.acc} />}
            </div> 
            : 
            null}
      {['multiple_coding_challenge'].includes(item.step) ? <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}><ShowACCList dataSource={item.acc} use_vetsmith_challenge_versioning={use_vetsmith_challenge_versioning}/></div> : null}
      {['technical_writing_assessment'].includes(item.step) ? <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}><ShowACCList dataSource={item.twas} use_vetsmith_challenge_versioning={true}/></div> : null}
      {['rlhf_challenge'].includes(item.step) ? <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}><ShowACCList dataSource={item.rlhfs} use_vetsmith_challenge_versioning={true}/></div> : null}
      {['ai_challenge'].includes(item.step) ? <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}><ShowACCList dataSource={item.ais} use_vetsmith_challenge_versioning={true}/></div> : null}
      {['nte_challenge'].includes(item.step) ? <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}><ShowACCList dataSource={item.ntes} use_vetsmith_challenge_versioning={true}/></div> : null}
      {['file_upload'].includes(item.step) ? (
        <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}>
          {!item.viewMode ? <>
            <div className='fileupload-list'>
              {item.step_config.map((stepConfig, i) => <FileUploadItem index={i} key={(i + 1) * 5} stepConfig={stepConfig} isLast={i + 1 === item.step_config.length} />)}
            </div>
            <div className='flieupload-list-start-upload'>
                <Button
                  title={'Please carefully select your file(s). Once a file is uploaded, it cannot be changed or modified.'}
                  size='large'
                  type='ant-btn ant-btn-primary' 
                  disabled={!isFileUploadAllowed} 
                  onClick={()=>item.uploadFiles(item.flow_id, item.flow_step_id)}>
                  {isFileUploadAllowed && <img src={cloudUploadIcon} /> }
                  {!isFileUploadAllowed && <img src={cloudUploadIconDisabled} /> }
                  <span>Upload selected files</span>
                </Button>
            </div>
          </>: 
          <>
            <br/>
            <div className='fileupload-list-view-mode'>
              {item.files.map((file, index) => (
                  <div key={(index * 5) + 4} className="hyperlink-link-status uploaded-file-details">
                    <img
                        src={roundCheck}
                        style={{
                          width: 18,
                          height: 18,
                          background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
                          opacity: 1
                        }}
                        alt="check"
                      /> 
                      <TruncatedFileName fileName={file.file_display_name}  mainClass="uploaded-file-name" />
                  </div>
              ))}
            </div>
          </>
          }
        </div>
      ) : null}
      {['hyperlink'].includes(item.step) ? (
        <div className={item.disabled ? 'Vetsmith-item-content1 disable-mcq-btn' : 'Vetsmith-item-content1'}>
          <div className='hyperlink-list'>
            {item.links.map((link, i) => (
              <>
                <div key={(i * 4) + 1} className="hyperlink-link-num">{i + 1}.</div>
                <div key={(i * 4) + 2} className="hyperlink-link-title">{link.hyperlink_title}</div>
                <div key={(i * 4) + 3} className="hyperlink-link-btn">
                  {
                    link.visited ?
                      <Button type='link' onClick={link.onClick}><span className="material-icons">link</span> <span>Visit link</span></Button>
                    :
                      <Button type='primary' ghost onClick={link.onClick}><span className="material-icons">link</span> <span>Visit link</span></Button>
                  }
                </div>
                <div key={(i * 4) + 4} className="hyperlink-link-status">{link.visited ? <span className="hyperlink-status hyperlink-viewed"><CheckMarkIcon fill="#1F5C2E"/> Link viewed</span> : <span className="hyperlink-status hyperlink-not-viewed">Not viewed yet</span>}</div>
              </>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

VetsmithItem.propTypes = {
  service: PropTypes.any,
  item: PropTypes.any
};

export default withVetsmithService(Vetsmith);
